import { render } from "./NameAndType.vue?vue&type=template&id=a30da7da&scoped=true"
import script from "./NameAndType.vue?vue&type=script&lang=js"
export * from "./NameAndType.vue?vue&type=script&lang=js"

import "./NameAndType.vue?vue&type=style&index=0&id=a30da7da&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a30da7da"]])

export default __exports__